module.exports = __webpack_public_path__ + "img/user10.db6dc465.jpg";